import type { Cart } from '@src/domains/cart/types/cart';

export const hasCartErrors = (cart?: Cart): boolean => {
  const cartItems = cart?.items ?? [];

  return (
    (!!cart?.generalErrors && cart.generalErrors.length > 0) ||
    cartItems.some((cartItem) => cartItem?.errors && cartItem.errors.length > 0)
  );
};
